import { connect } from 'react-redux';
import CognitoFormsAdminScreen from '../components/CognitoFormsAdminScreen';
import storage from '../../../../../lib/Storage';
import { cognitoFormAdminShowForm } from '../../../../../state/modules/cognitoFormsAdmin/actions';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    total: state.cognitoFormsAdmin.get('total'),
    isLoading: state.cognitoFormsAdmin.get('isLoading'),
    activeId: storage.get(findStorageType(), 'partnershipId'),
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showForm: (id) => {
      dispatch(cognitoFormAdminShowForm(id));
    },
  };
};

const CognitoFormsAdminScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormsAdminScreen);

export default CognitoFormsAdminScreenContainer;
